import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './assets/css/reset.css'
import './assets/css/gb.css'
import { api } from './api/api'

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import SwiperCore, { Autoplay } from 'swiper'

import moment from 'moment'

import layer from 'vue-layer'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

// 中文简体
moment.locale('zh-cn')
Vue.filter('dateformat', (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') => {
  return moment(dataStr).format(pattern)
})

Vue.prototype.$layer = layer(Vue)

Vue.use(vueSwiper)

SwiperCore.use([Autoplay])

Vue.config.productionTip = false

Vue.prototype.axios = axios

Vue.prototype.$api = api

var webTitle = ''

Vue.prototype.bus = new Vue()

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    if (webTitle === '' || !webTitle) {
      api.getConfig('webTitle').then(res => {
        webTitle = res.data.ConfigValue
        document.title = to.meta.title + ' - ' + webTitle
      })
    }
    document.title = to.meta.title + '-' + webTitle
    api.getAllConfig().then(res => {
      store.commit('saveAndroidCode', res.data.androidCode)
      store.commit('saveIosCode', res.data.iosCode)
      store.commit('saveAndroidUrl', res.data.androidUrl)
      store.commit('saveIosUrl', res.data.iosUrl)
      store.commit('saveMobileWebCode', res.data.mobileWebCode)
      store.commit('saveQqGroupNum', res.data.qqGroupNum)
      store.commit('saveQqService', res.data.qqService)
      store.commit('saveCompanyNameCn', res.data.companyNameCn)
      store.commit('saveCompanyNameEn', res.data.companyNameEn)
      store.commit('saveIcpNum', res.data.icpNum)
      store.commit('saveWechatService', res.data.wechatService)
      store.commit('saveWechatOfficialAccounts', res.data.wechatOfficialAccounts)
      store.commit('saveWechatOfficialCode', res.data.wechatOfficialCode)
    })
  }
  next()
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js